import { ServiceMode } from 'state/service-mode';
import { StoreProxy } from 'state/store';
import { POSVendor } from 'state/store/hooks/enums';

export const isCurbsideOrder = (store: StoreProxy, serviceMode?: ServiceMode) => {
  const isInStoreCarrols =
    serviceMode &&
    [ServiceMode.EAT_IN, ServiceMode.TAKEOUT].includes(serviceMode) &&
    store.pos?.vendor === POSVendor.CARROLS;
  return serviceMode === ServiceMode.CURBSIDE || isInStoreCarrols;
};
